import React, { createContext, useContext, useState } from "react";
import * as api from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(api.getUser());

  const aplicar = (resp) => {
    api.setToken(resp.token);
    const u = {
      id: resp.usuarioId, nome: resp.nome, email: resp.email,
      tipo: resp.tipo, empresaId: resp.empresaId, ehAdmin: resp.ehAdmin === true,
      notificarEmail: resp.notificarEmail, notificarWhatsapp: resp.notificarWhatsapp,
    };
    api.setUser(u);
    setUserState(u);
    return u;
  };

  const login = async (email, senha) => aplicar(await api.login(email, senha));
  const registrar = async (dados) => aplicar(await api.registrar(dados));
  const reivindicar = async (empresaId) => aplicar(await api.reivindicarEmpresa(empresaId));
  const impersonarEmpresa = async (empresaId) => aplicar(await api.impersonarEmpresa(empresaId));
  // Impersonação de candidato precisa de MARCA EXPLÍCITA: a conta do admin também é do tipo "candidato",
  // então deduzir pelo tipo marcava o admin como impersonando o tempo todo (e o botão de voltar deslogava
  // em laço). A marca some ao voltar e ao deslogar.
  const impersonarCandidato = async (usuarioId) => {
    const u = aplicar(await api.impersonarCandidato(usuarioId));
    if (usuarioId) localStorage.setItem("eairh_imp_cand", String(usuarioId));
    else localStorage.removeItem("eairh_imp_cand");
    return u;
  };
  // Assume QUALQUER usuario (candidato ou empresa). Usa a mesma marca do impersonarCandidato porque o
  // problema e o mesmo: sem ela, o admin (que tambem e conta de candidato) apareceria como impersonando
  // para sempre e o botao de voltar entraria em laco.
  const impersonarUsuario = async (usuarioId) => {
    const u = aplicar(await api.impersonarUsuarioReq(usuarioId));
    if (usuarioId) localStorage.setItem("eairh_imp_cand", String(usuarioId));
    return u;
  };
  const setPrefs = (notificarEmail, notificarWhatsapp) =>
    setUserState((u) => { const nu = { ...u, notificarEmail, notificarWhatsapp }; api.setUser(nu); return nu; });
  // Atualiza campos do usuário no contexto + localStorage (ex.: nome após editar a conta) — evita nome defasado no Header/denúncia.
  const atualizar = (campos) =>
    setUserState((u) => { if (!u) return u; const nu = { ...u, ...campos }; api.setUser(nu); return nu; });
  const logout = () => { localStorage.removeItem("eairh_imp_cand"); api.setToken(null); api.setUser(null); setUserState(null); };

  return (
    <AuthContext.Provider value={{ user, login, registrar, reivindicar, impersonarEmpresa, impersonarCandidato, impersonarUsuario, setPrefs, atualizar, logout, isEmpresa: user?.tipo === 1, isAdmin: user?.ehAdmin === true }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
